const formatCoordinate = value => value.toFixed(1);

const Content = ({icao, name, latitude, longitude, isAirport}) => (
    <a>
        <span className="shop" />
        {isAirport && <span>✈ </span>}
        {icao && <span className="icao">[{icao}]</span>}
        <span className="name">{name}</span>
        {(latitude || longitude) && (
            <span className="coordinates">({formatCoordinate(latitude)}, {formatCoordinate(longitude)})</span>
        )}
    </a>
);

export default Content;
